import { render, staticRenderFns } from "./tiledetail.vue?vue&type=template&id=fa0ae35a&scoped=true&class=geofence-mainview&"
import script from "./tiledetail.vue?vue&type=script&lang=js&"
export * from "./tiledetail.vue?vue&type=script&lang=js&"
import style0 from "./tiledetail.vue?vue&type=style&index=0&id=fa0ae35a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa0ae35a",
  null
  
)

export default component.exports